import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetchBoardCommentList, fetchBoardCommentItem, postBoardCommentItem, putBoardCommentItem, deleteBoardCommentItem } from ".";
import { isDebug } from "../../utils";


export const useBoardCommentListQuery = (queryOptions) => {
    return useQuery({
        queryKey: ["board-comment-of-list", queryOptions],
        queryFn: () => fetchBoardCommentList(queryOptions),
        select: (response) => {
            return response.data || {};
        },
        onError: (error) => {
            console.error("Error fetching Board Comment List API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
    });
};

export const useBoardCommentItemQuery = (board_id, comment_id) => {
    return useQuery({
        queryKey: ["board-comment-of-item", {board_id, comment_id}],
        queryFn: () => fetchBoardCommentItem(board_id, comment_id),
        select: (response) => {
            return response.data || {};
        },
        onError: (error) => {
            console.error("Error fetching Board Comment item API contracts:", new Date().toISOString(), error);
        },
        staleTime: 1000 *  process.env.REACT_APP_USE_QUERY_STALE_TIME, // env Value default(1)
        refetchOnWindowFocus: false,
        enabled: (board_id > 0 && comment_id > 0),
    });
};

export const useBoardCommentItemPostMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: postBoardCommentItem,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ Board Comment item posted successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["post-board-comment-item"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to post Board Comment item :", new Date().toISOString(), error);
        },
    });
};

export const useBoardCommentItemPutMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: putBoardCommentItem,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ BoardComment item put successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["put-board-comment-item"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to put Board Comment item :", new Date().toISOString(), error);
        },
    });
};

export const useBoardCommentItemDeleteMutation = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: deleteBoardCommentItem,
        onSuccess: () => {
            if (isDebug()) console.log("#@#@ Board Comment item deleted successfully!", new Date().toISOString());
            queryClient.invalidateQueries(["delete-board-comment-item"]);
        },
        onError: (error) => {
            console.error("#@#@ Failed to delete Board Comment item :", new Date().toISOString(), error);
        },
    });
};